//import { createRouter, createWebHashHistory } from 'vue-router'
// const router = createRouter({
//   //history: createWebHistory(import.meta.env.BASE_URL),
//   history: createWebHashHistory(),
//   routes: [
//     {path: '/', name: 'layout', component: import('../components/Layout.vue'),
//       children:[
//         {path: '/',name: 'home',component: import('../views/Home.vue'),},
//         {path: '/DataTable',name: 'DataTable',component: import('../views/DataTable.vue'),},
//         {path: '/AIassistant',name: 'AIassistant',component: import('../views/AIassistant.vue'),},
//         {path: '/DetailView/:id', name: 'DetailView', component: import('../views/DetailView.vue')}
//       ]}, 
//   ],
// })

// export default router


// import Layout from '../components/Layout.vue'      // 同步
// import Home from '../views/Home.vue'
// import DataTable from '../views/DataTable.vue'
// import AIassistant from '../views/AIassistant.vue'
// import DetailView from '../views/DetailView.vue'

// const router = createRouter({
//   history: createWebHashHistory(),
//   routes: [
//     {
//       path: '/',
//       component: Layout,
//       children: [
//         { path: '', name: 'home', component: Home },
//         { path: '/DataTable', name: 'DataTable', component: DataTable },
//         { path: '/AIassistant', name: 'AIassistant', component: AIassistant },
//         { path: '/DetailView/:id', name: 'DetailView', component: DetailView }
//       ]
//     }
//   ]
// })
// export default router


import { createRouter, createWebHashHistory,createWebHistory } from 'vue-router'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  //history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      name: 'layout',                 // ← 1. 给个名字
      component: () => import('../components/Layout.vue'), // ← 2. 箭头函数
      children: [
        { path: '', name: 'home', component: () => import('../views/Home.vue') },
        { path: '/Literature', name: 'Literature', component: () => import('../views/Literature.vue') },
        { path: '/PaperDetail/:id', name: 'PaperDetail', component: () => import('../views/PaperDetail.vue') },
        { path: '/DataTable', name: 'DataTable', component: () => import('../views/DataTable.vue') },
        { path: '/AIassistant', name: 'AIassistant', component: () => import('../views/AIassistant.vue') },
        { path: '/CaseCorrection/:id?', name: 'CaseCorrection', component: () => import('../views/CaseCorrection.vue') },
        { path: '/Contact', name: 'Contact', component: () => import('../views/Contact.vue') }
      ]
    }
  ]
})

export default router
